var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgLoadingOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30321_86254)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6398 21.1414C44.0076 25.2235 43.1567 29.3231 41.1946 32.9216C39.2325 36.5201 36.2474 39.456 32.6168 41.3579C28.9862 43.2599 24.8731 44.0426 20.7976 43.607C16.7222 43.1713 12.8674 41.537 9.72086 38.9106C6.57427 36.2842 4.27716 32.7837 3.12002 28.8517C1.96288 24.9198 1.99768 20.7331 3.22002 16.8209C4.44236 12.9088 6.79733 9.44692 9.98714 6.87318C13.177 4.29944 17.0583 2.72939 21.1405 2.36157L20.9361 0.09375C20.1687 0.162898 19.4077 0.270331 18.6557 0.41497C14.9681 1.12427 11.4979 2.7284 8.55731 5.10109C5.01701 7.95763 2.40328 11.7998 1.04663 16.1418C-0.31001 20.4838 -0.348633 25.1306 0.935649 29.4946C2.21993 33.8586 4.76943 37.7437 8.26176 40.6587C11.7541 43.5737 16.0324 45.3876 20.5556 45.8711C25.0789 46.3546 29.6439 45.4859 33.6735 43.3749C37.703 41.264 41.0161 38.0055 43.1938 34.0116C45.0026 30.6942 45.9605 26.9931 45.9992 23.2382C46.0071 22.4724 45.9768 21.7045 45.9076 20.9371L43.6398 21.1414Z",
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0002 43.7234C18.9016 43.7234 14.8949 42.508 11.487 40.2309C8.07911 37.9538 5.42296 34.7173 3.85447 30.9306C2.28598 27.144 1.87559 22.9772 2.6752 18.9573C3.47481 14.9374 5.44851 11.2449 8.3467 8.3467C11.2449 5.44851 14.9374 3.47481 18.9573 2.6752C22.9772 1.87559 27.144 2.28598 30.9306 3.85447C34.7173 5.42296 37.9538 8.07911 40.2309 11.487C42.508 14.8949 43.7234 18.9016 43.7234 23.0002H46.0004C46.0004 22.2297 45.9617 21.4621 45.8852 20.7002C45.5096 16.9638 44.2234 13.3637 42.1242 10.222C39.5969 6.43962 36.0048 3.49163 31.802 1.7508C27.5993 0.00996554 22.9747 -0.445515 18.5131 0.441953C14.0515 1.32942 9.95325 3.51998 6.73662 6.73662C3.51998 9.95325 1.32942 14.0515 0.441953 18.5131C-0.445515 22.9747 0.00996566 27.5993 1.7508 31.802C3.49163 36.0048 6.43962 39.5969 10.222 42.1242C13.3637 44.2234 16.9638 45.5096 20.7002 45.8852C21.4621 45.9617 22.2297 46.0004 23.0002 46.0004V43.7234Z",
    fill: "var(--secondary-6)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30321_86254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingOutlined);
export default __webpack_public_path__ + "static/media/loadingOutlined.1de9d9f2f45d9246f8a229d5c8fb8caa.svg";
export { ForwardRef as ReactComponent };